// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__tyde5","messages":"Chat_messages__1VzDW","dateDivider":"Chat_dateDivider__b9vQ8"};